import { styled } from '@linaria/react';
export const OffersWrapper = /*#__PURE__*/styled('div')({
  name: "OffersWrapper",
  class: "o1naj0io",
  propsAsIs: false
});
export const Legend = /*#__PURE__*/styled('div')({
  name: "Legend",
  class: "l1m33r22",
  propsAsIs: false
});
export const LegendWrapper = /*#__PURE__*/styled('div')({
  name: "LegendWrapper",
  class: "l1tv2iss",
  propsAsIs: false
});
const LegendBox = /*#__PURE__*/styled('div')({
  name: "LegendBox",
  class: "lwomp3i",
  propsAsIs: false
});
const _exp10 = /*#__PURE__*/() => LegendBox;
export const LegendBoxGreen = /*#__PURE__*/styled(_exp10())({
  name: "LegendBoxGreen",
  class: "ls5wdpf",
  propsAsIs: true
});
const _exp12 = /*#__PURE__*/() => LegendBox;
export const LegendBoxRed = /*#__PURE__*/styled(_exp12())({
  name: "LegendBoxRed",
  class: "l1fdaiss",
  propsAsIs: true
});

require("./AvailabilityHelpers.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AvailabilityHelpers.tsx");